import { Card, Accordion } from 'react-bootstrap'

export const SimpleFold = ({ children, header = "Details" }) => {
  return <Accordion defaultActiveKey={null}>
    <Accordion.Item>
      <Accordion.Header style={{ padding: 0 }}>{header}</Accordion.Header>
      <Accordion.Body>
        {children}
      </Accordion.Body>
    </Accordion.Item>
  </Accordion>;
}

export const GeometryCard = ({ src, bodytext }) => {
  return <Card style={{ width: "20em" }}>
    <Card.Body style={{ width: "100%", textAlign: "center" }}>
      <span style={{ width: "100%", textAlign: "center", marginBottom: "0.2em" }}>{bodytext}</span><br />
      <img src={src} style={{ maxWidth: "100%", maxHeight: "15em" }} alt={bodytext} />
    </Card.Body>
  </Card>
}

